import clsx from 'clsx'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import { getClassNameByDepth } from '../utils'
import { TreeBranch } from './TreeBranch'

const useStyles = makeStyles(() => ({
  '@keyframes pulse': {
    '0%': {
      opacity: 0.5
    },
    '100%': {
      opacity: 1
    }
  },
  animatePulse: {
    animation: '$pulse 1.5s ease-in-out infinite alternate'
  }
}))

function LoadingState () {
  const classes = useStyles()
  const { classNames, styles, includeAvatar } = useVisualBlocksContext()
  const blockClassName = getClassNameByDepth(classNames, 'block', 0)
  return (
    <div
      className={clsx('flex flex-row gap-2 w-full', classNames?.container)}
      style={{ minHeight: '500px', ...(styles?.container ?? {}) }}
    >
      {includeAvatar && (
        <>
          <div className='flex items-center'>
            <div
              className={clsx('radius-round bg-neutral-300', classes.animatePulse)} style={{
                width: '96px',
                height: '96px'
              }}
            />
          </div>

          <TreeBranch />
        </>
      )}

      <div className='w-full'>
        <div className='h-full w-full flex gap-5'>
          <div className={clsx('flex h-full w-full bg-neutral-300 animate-pulse rounded', blockClassName, classes.animatePulse)} style={{ width: '200px' }} />

          <TreeBranch />

          <div className={clsx('flex-1 flex flex-col gap-5', blockClassName, classes.animatePulse)}>
            <div className={clsx('flex h-full w-full bg-neutral-300 animate-pulse rounded', blockClassName, classes.animatePulse)} />
            <div className={clsx('flex h-full w-full bg-neutral-300 animate-pulse rounded', blockClassName, classes.animatePulse)} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingState
